/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountryResource
 */
export interface CountryResource {
    /**
     * 
     * @type {string}
     * @memberof CountryResource
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof CountryResource
     */
    label?: string;
}

/**
 * Check if a given object implements the CountryResource interface.
 */
export function instanceOfCountryResource(value: object): value is CountryResource {
    return true;
}

export function CountryResourceFromJSON(json: any): CountryResource {
    return CountryResourceFromJSONTyped(json, false);
}

export function CountryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryResource {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function CountryResourceToJSON(value?: CountryResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'label': value['label'],
    };
}

